<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--작업내용-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001859') }}</span>
				</div>
			</div>

			<template>
				<sf-data-table
					ref="roPwaApcnTable"
					:paging="false"
					:columns="roApcnSwapPartsCols"
					:rows="rows"
					:excel="false"
					:stripe="false"
					:addRowData="addRowData"
					fit
					selection
					height="300px"
				>
					<!--컬럼에 아이콘 등록방법 시작 -->
					<template v-slot:customRows="slotProps">
						<template v-if="slotProps.column.property === 'partNo'">
							<!-- {{ test(slotProps) }} -->
							<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
								<!-- 버튼 
								<sf-button line icon="square-plue" :onClick="addAction">
									{{ getMessage_('MWCC000007') }}
								</sf-button>
								-->
								<el-input v-model="slotProps.row[slotProps.column.property]" maxlength="20" readOnly />
								<span class="unit input-icon">
									<i class="icon-sf-search search-icon" @click="onCausePartPopup(slotProps)" :style="searchStye"></i>
								</span>
							</template>
							<template v-else>
								{{ slotProps.row.partNo }}
							</template>
						</template>

						<template v-if="slotProps.column.property === 'qty'">
							<!-- 수량 -->
							<template v-if="slotProps.row.rowType === 'add' || slotProps.row.rowType === 'addT' || roApcnPopUp.btnTsAuth">
								<el-input :value="slotProps.row[slotProps.column.property]" maxlength="3" @input="val => onChange(val, slotProps)" />
							</template>
							<template v-else>
								{{ slotProps.row.qty }}
							</template>
						</template>

						<!-- amt 금액/자재비-->
						<template v-if="slotProps.column.property === 'amt'">
							{{ Math.round(slotProps.row.partCst * slotProps.row.qty * 100) / 100 }}
						</template>

						<template v-if="slotProps.column.property === 'partCst'">
							<!-- 부품가격 -->
							<template v-if="slotProps.row.zeroGb === true">
								<el-input :value="slotProps.row[slotProps.column.property]" maxlength="7" @input="val => onChange(val, slotProps)" />
							</template>
							<template v-else>
								{{ slotProps.row.partCst }}
							</template>
						</template>

						<template v-if="slotProps.column.property === 'lts'">
							<!-- lts -->
							<template v-if="slotProps.row.ltsZeroGb === true">
								<el-input :value="slotProps.row[slotProps.column.property]" maxlength="7" @input="val => onChange(val, slotProps)" />
							</template>
							<template v-else>
								{{ slotProps.row.lts }}
							</template>
						</template>

						<!--공임비 wags -->
						<template v-if="slotProps.column.property === 'wags'">
							{{ Math.round(slotProps.row.lts * slotProps.row.stdCst * 100) / 100 }}
						</template>
					</template>
					<!--컬럼에 아이콘 등록방법 끝 -->

					<!--버튼부 시작-->
					<template v-slot:actionsRight v-if="roApcnPopUp.btnTsAuth">
						<!-- test code -->

						<sf-button size="sm" line icon="square-plue" :onClick="addGirdAction">
							{{ getMessage_('MWCC000007') }}
						</sf-button>

						<sf-button size="sm" color="error" line icon="trash" :onClick="deleteGridAction">
							{{ getMessage_('MWCC000328') }}
						</sf-button>
					</template>
					<!--버튼부 끝 -->
				</sf-data-table>
			</template>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import utils from '@/utils';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			addRowData: {
				//행추가 이벤트시 필요한부분
				rowType: 'add',
				partNo: '',
				partNm: '',
				opCd: '', //op코드
				opNm: '', //op명
				lts: '', //lts
				qty: '',
				partCst: '', //as 부품가격
				stdCst: '', //기준금액
				zeroGb: false,
				ltsZeroGb: false
			},
			searchStye: {
				//그리드 버튼 스타일 지정
				top: '8px',
				right: '7px'
			},
			partNoInput: '', //품번팝업 호출시 매개체
			selGridRowIndex: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		rows() {
			//그리드 로우
			return this.roApcnSwapPartsList;
		},
		roApcnSwapPartsCols() {
			//그리드 컬럼
			return [
				{
					label: '* ' + this.getMessage_('QWCC001037'), // END 품번
					prop: 'partNo',
					width: '150px',
					sortable: false,
					headerAlign: 'center',
					custom: true
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					width: '250px',
					sortable: false,
					headerAlign: 'center',
					form: {
						type: 'input',
						isDisabled: () => true //추가된행은 편집을 못하게 한다.
					}
				},
				{
					label: this.getMessage_('QWCC001096'), //OP코드
					prop: 'opCd',
					align: 'center',
					width: '150px'
				},
				{
					label: this.getMessage_('QWCC001807'), //OP코드명
					prop: 'opNm',
					align: 'center',
					width: '200px'
				},

				{
					label: this.getMessage_('QWCC001040'), // 부품가격
					prop: 'partCst',
					width: '120px',
					sortable: false,
					custom: true
					/*
					form: {
						type: 'number',
						isDisabled: this.isDisabled, //추가된행은 편집을 못하게 한다.
						validation: { maxByteSize: 7 }
					}
					*/
				},
				{
					label: '* ' + this.getMessage_('QWCC000977'), // 교환부품수량
					prop: 'qty',
					width: '130px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001101'), // 자재비
					prop: 'amt',
					width: '100px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001100'), //LTS
					prop: 'lts',
					width: '100px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001861'), // 기준금액
					prop: 'stdCst',
					width: '100px',
					sortable: false,
					form: {
						type: 'number',
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001102'), // 공임비
					prop: 'wags',
					minWidth: '100px',
					sortable: false,
					custom: true
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		onChange(value, slotProps) {
			//console.log('>>>>>>>>>>>>>>>>>>>>>>>>', slotProps);
			const key = slotProps.column.property;
			if (key === 'qty') {
				value = value.replace(/[^0-9]/g, '');
				if (value.length > 3) {
					value = value.slice(0, 3);
				}
			} else if (key === 'partCst') {
				value = value.replace(/[^-\.0-9]/g, '');
				const arr = value.toString().split('.');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 16) {
						value = value.slice(0, 16);
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 2) {
						arr[1] = arr[1].slice(0, 2);
					}
					if (arr[0].length > 16) {
						arr[0] = arr[0].slice(0, 16);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
			} else if (key === 'lts') {
				const arr = value.toString().split('.');
				value = value.replace(/[^.0-9]/g, '');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 2) {
						value = value.slice(0, 2) + '.';
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 1) {
						arr[1] = arr[1].slice(0, 1);
					}
					if (arr[0].length > 3) {
						arr[0] = arr[0].slice(0, 3);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
			}
			slotProps.row[key] = value;
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') {
				return false;
			} else {
				return true;
			}
		},
		addGirdAction() {
			//행추가

			let camPaignNo = convertNvl(convertNvl(this.currentCmpnNm, ''), convertNvl(this.roApcnPopUp.cmpnNo, ''));
			//console.log('camPaignNo값은>>>?', camPaignNo);
			if (camPaignNo != '') {
				//캠페인은 작업내용 추가가 불가합니다
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001883') });
				return false;
			} else {
				let addRowData = { ...this.addRowData };
				this.rows.push(addRowData);
				this.$refs.roPwaApcnTable.getTable().toggleRowSelection(addRowData);
				/*
				setTimeout(() => {
					let node = document.querySelector('.el-table__body-wrapper tbody > tr:nth-of-type(1) > td:nth-of-type(3) input');
					node.focus();
				}, 1);
				*/
			}
		},
		addPartInoGirdAction(partInfo) {
			//console.log('값은<><<<이건가', partInfo);
			//console.log('this.stdCst', this.stdCst);
			//행추가
			let addRowData = {
				//행추가 이벤트시 필요한부분
				rowType: 'addT', //cAdd addT
				partNo: partInfo.partNo,
				partNm: partInfo.partNm,
				opCd: partInfo.opCd, //op코드
				opNm: partInfo.opNm, //op명
				lts: partInfo.lts, //lts
				qty: '',
				partCst: partInfo.asCst, //as부품가격
				stdCst: partInfo.stdCst, //기준금액
				zeroGb: partInfo.zeroGb,
				ltsZeroGb: partInfo.ltsZeroGb,
				causYn: 'Y' ////원인부품에서 추가된것은 Y으로 추가함
			};

			let addChkCnt = 0;

			const selectedMaps = this.roApcnSwapPartsList.slice();

			const mapData = {};

			selectedMaps.forEach((mapData, index) => {
				const { causYn } = mapData;

				if (selectedMaps[index].causYn === 'Y') {
					addChkCnt++;

					selectedMaps[index].partNo = addRowData.partNo;

					selectedMaps[index].partNm = addRowData.partNm;

					selectedMaps[index].partCst = addRowData.partCst;

					selectedMaps[index].opCd = addRowData.opCd;
					selectedMaps[index].opNm = addRowData.opNm;
					selectedMaps[index].lts = addRowData.lts;
					selectedMaps[index].stdCst = addRowData.stdCst;
					selectedMaps[index].zeroGb = addRowData.zeroGb;
					selectedMaps[index].ltsZeroGb = addRowData.ltsZeroGb;
					selectedMaps[index].causYn = addRowData.causYn;

					//console.log('2>>>>', selectedMaps[index]);
				}
			});

			if (addChkCnt === 0) {
				this.rows.unshift(addRowData);
				this.$refs.roPwaApcnTable.getTable().toggleRowSelection(addRowData);
			}

			// this.tmpPartNo = partInfo.partNo;
			// this.tmpOpCd = partInfo.opCd;
			// this.tmpLts = partInfo.lts;
		},
		onCausePartPopup(param) {
			//console.log('this.roApcnPopUp.readOnlyAuth1>>>>>', this.roApcnPopUp.readOnlyAuth1);

			if (this.roApcnPopUp.readOnlyAuth1 == false) {
				//원인부품명
				//this.partNoInput = param.row.partNo;
				//this.selGridRowIndex = param.index; //그리드에서 선택한 해당행의 인덱스.
				//this.$emit('OpenGridPartPopup', this.partNoInput); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.

				let causePartInfo = {
					partNoInput: this.causPartNo,
					cmpnNoInfo: true //PWA제약조건을 false로 주면 된다
				};
				this.selGridRowIndex = param.index; //그리드에서 선택한 해당행의 인덱스.
				this.$emit('OpenGridPartPopup', causePartInfo);
			}
		},
		deleteGridAction() {
			//delete버튼
			//console.log('@@@@ delete action');
			let camPaignNo = convertNvl(convertNvl(this.currentCmpnNm, ''), convertNvl(this.roApcnPopUp.cmpnNo, ''));
			let pwaNo = convertNvl(this.roApcnPopUp.pwaNo, '');
			if (camPaignNo != '') {
				//캠페인은 작업내용 삭제가 불가합니다
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001888') });
			} else if (pwaNo != '') {
				const selectedRows = this.$refs.roPwaApcnTable.getSelectedRows();
				const selectedMaps = this.roApcnSwapPartsList.slice();
				const mapData = {};

				if (selectedRows.length < 1) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('MWCC000109'),
						message: this.getMessage_('MWCC000110')
					}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
					return;
				}

				//console.log('selectedMaps>>>>>', this.roApcnSwapPartsList);

				selectedMaps.forEach((mapData, index) => {
					const { partNo, opCd, qty, partCst, amt, causYn } = mapData;

					//let causYn = selectedMaps[index].causYn;
					let partNo1 = selectedMaps[index].partNo;
					let partNm2 = selectedMaps[index].partNm;

					//console.log('causYn>>>>>>>', causYn);
					//console.log('partNo1>>>>>>>', partNo1);
					//console.log('partNo1>>>>>>>', partNo1);

					if (
						selectedRows.map(selRow => selRow.partNo).includes(partNo) &&
						selectedRows.map(selRow => selRow.opCd).includes(opCd) &&
						selectedRows.map(selRow => selRow.qty).includes(qty) &&
						selectedRows.map(selRow => selRow.partCst).includes(partCst) &&
						selectedRows.map(selRow => selRow.amt).includes(amt) &&
						selectedRows.map(selRow => selRow.causYn).includes(causYn)
					) {
						//추가된 항목만 삭제하기 위함
						if (causYn == 'N') {
							delete selectedMaps[index];
						}
					}
				});

				this.setState_({ key: 'roApcnSwapPartsList', value: selectedMaps.filter(mapData => !this.isUndefined(mapData)) });
			} else {
				const selectedRows = this.$refs.roPwaApcnTable.getSelectedRows();
				const selectedMaps = this.roApcnSwapPartsList.slice();
				const mapData = {};

				if (selectedRows.length < 1) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('MWCC000109'),
						message: this.getMessage_('MWCC000110')
					}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
					return;
				}

				//console.log('selectedMaps>>>>>', this.roApcnSwapPartsList);

				selectedMaps.forEach((mapData, index) => {
					const { partNo, opCd, qty, partCst, amt, causYn } = mapData;

					//let causYn = selectedMaps[index].causYn;
					let partNo1 = selectedMaps[index].partNo;
					let partNm2 = selectedMaps[index].partNm;

					//console.log('causYn>>>>>>>', causYn);
					//console.log('partNo1>>>>>>>', partNo1);
					//console.log('partNo1>>>>>>>', partNo1);

					if (
						selectedRows.map(selRow => selRow.partNo).includes(partNo) &&
						selectedRows.map(selRow => selRow.opCd).includes(opCd) &&
						selectedRows.map(selRow => selRow.qty).includes(qty) &&
						selectedRows.map(selRow => selRow.partCst).includes(partCst) &&
						selectedRows.map(selRow => selRow.amt).includes(amt) &&
						selectedRows.map(selRow => selRow.causYn).includes(causYn)
					) {
						//추가된 항목만 삭제하기 위함

						delete selectedMaps[index];
					}
				});

				for (var i = 0; i < selectedRows.length; i++) {
					//console.log('뭐지>>>>>', selectedRows[i].causYn);

					if (selectedRows[i].causYn == 'Y') {
						let causePartInfo = {
							causPartNo: selectedRows[i].partNo,
							causPartNm: selectedRows[i].partNm
						};
						this.$emit('ResetCauInfoReset', causePartInfo);
					} // end if
				} //end for

				this.setState_({ key: 'roApcnSwapPartsList', value: selectedMaps.filter(mapData => !this.isUndefined(mapData)) });
			}
		} /*,
		deleteGridAction() {
			//delete버튼
			//console.log('@@@@ delete action');
			const selected = this.$refs.roPwaApcnTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			let tmpRoNo = this.roApcnPopUp.roNo || '';

			let delValiGb = false;

			//PWA에서 넘어온행들은 먼저 저장을 해야됩니다.
			if (tmpRoNo === '') {
				delValiGb = true;
			}

			this.$refs.roPwaApcnTable.multipleSelection.forEach(row => {
				if (row.rowType === 'add') {
					delValiGb = true;
				}
			});

			if (delValiGb === true) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC000917') });
				return false;
			}

			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.remove(selected) }] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
		},*/,
		remove(selected) {
			//console.log('@@@@ delete');

			this.$sf_toggleLoading(true);
			this.delApcnRoSwapInfoList_(selected)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					// this.$refs.varTable.deleteHandler(false);
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			//this.$emit('Refresh');
		},
		gridParNoPopUp(param) {
			//console.log('값은1>>>>>>>>>>>>>>', param);
			//console.log('그리드에서 선택한 인덱스값>>>>>>>>>>>>>>>>', this.selGridRowIndex);

			//중복된행 있으면 체크해서 추가 안되도록 처리함.
			const selectedMaps = this.roApcnSwapPartsList.slice();
			const mapData = {};
			let dupCnt = 0;

			selectedMaps.forEach((mapData, index) => {
				const { partNo, opCd } = mapData;

				if (
					selectedMaps.map(selRow => selRow.partNo).includes(param.partNo) &&
					selectedMaps.map(selRow => selRow.opCd).includes(param.opCd)
				) {
					dupCnt++;
				}
			});

			//console.log('값은>>>>', this.getPwaEndPartStdCst_);

			if (dupCnt == 0) {
				let dataArr = this.roApcnSwapPartsList.slice();
				dataArr[this.selGridRowIndex].partNo = param.partNo;
				dataArr[this.selGridRowIndex].partNm = param.partNm;
				dataArr[this.selGridRowIndex].opCd = param.opCd;
				dataArr[this.selGridRowIndex].opNm = param.opNm;
				dataArr[this.selGridRowIndex].partCst = param.asCst;
				dataArr[this.selGridRowIndex].lts = param.lts;

				dataArr[this.selGridRowIndex].stdCst = param.stdCst;
				dataArr[this.selGridRowIndex].causYn = 'N'; //작업내용에서 추가된것은 N으로 추가함

				if (param.asCst == 0) {
					dataArr[this.selGridRowIndex].zeroGb = true;
				} else {
					dataArr[this.selGridRowIndex].zeroGb = false;
				}
				if (param.lts == 0) {
					dataArr[this.selGridRowIndex].ltsZeroGb = true;
				} else {
					dataArr[this.selGridRowIndex].ltsZeroGb = false;
				}
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001868') }); //이미 등록된 작업내용이 존재합니다. 확인해주세요.
				return false;
			}
		},
		gridCheckRowData() {
			/* 상위 저장 버튼시 이 함수를 호출함 체크된행만 리턴함*/
			return this.$refs.roPwaApcnTable.getSelectedRows();
		},
		deletePartGridAction(parmList) {
			const selectedPartNo = parmList;
			const selectedMaps = this.roApcnSwapPartsList.slice();
			const mapData = {};

			selectedMaps.forEach((mapData, index) => {
				const { partNo } = mapData;

				if (selectedPartNo.map(selRow2 => selRow2.partNo).includes(partNo)) {
					delete selectedMaps[index];
				}
			});

			this.setState_({ key: 'roApcnSwapPartsList', value: selectedMaps.filter(mapData => !this.isUndefined(mapData)) });
		},

		/*******************************************얼그레이아이스티 ******************************/
		//캠페인 선택 교환부품목록 세팅
		deletePartList() {
			this.DEFAULT_ASSIGN({
				key: 'popupSelected',
				value: []
			});

			this.DEFAULT_ASSIGN({
				key: 'roApcnSwapPartsList',
				value: []
			});
		}
		/********************************************얼그레이아이스티 ******************************/
	},
	watch: {
		//삭제Flag
		isDelPwaCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelPwaCompInitFlag) {
				//this.deletePartList();
			}
		},
		isDelCamPaignCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			//if (this.isDelCamPaignCompInitFlag) {
			//	this.deletePartList();
			//}
		}
	}
};
</script>
